import { lazy, ReactElement, Suspense } from 'react';
import { Box, Spinner } from '@ff-it/ui';

const config = window.__RUNTIME_CONFIG__ as any;

// Lazy loaded components - only loaded if HUB is enabled
const QuotaDisplay = config?.HUB_ENABLED
  ? lazy(() =>
      import('./QuotaDisplay').then((m) => ({
        default: m.QuotaDisplay,
      })),
    )
  : null;

const RefreshQuotaOnUpdate = config?.HUB_ENABLED
  ? lazy(() =>
      import('./RefreshQuotaOnUpdate').then((m) => ({
        default: m.RefreshQuotaOnUpdate,
      })),
    )
  : null;

export function LazyQuotaDisplay(): ReactElement | null {
  if (!QuotaDisplay) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <Box py="2" mx="auto">
          <Spinner color="primary" />
        </Box>
      }
    >
      <QuotaDisplay />
    </Suspense>
  );
}

export function LazyRefreshQuotaOnUpdate(): ReactElement | null {
  if (!RefreshQuotaOnUpdate) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <RefreshQuotaOnUpdate />
    </Suspense>
  );
}
